import(/* webpackMode: "eager" */ "/vercel/path0/src/app/benefits/page.tsx");
